module.exports = __webpack_public_path__ + "static/media/Sketchy.110282d9.jpeg";